export const isFilled = (_) => _ !== null && _ !== undefined;
